import { render, staticRenderFns } from "./TeacherAdminIndex.vue?vue&type=template&id=51b5bf27&scoped=true&"
import script from "./TeacherAdminIndex.vue?vue&type=script&lang=js&"
export * from "./TeacherAdminIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b5bf27",
  null
  
)

export default component.exports